import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import masterEn from "./en/masterEn";
import settingsEn from "./en/settings";
import projectEn from "./en/projectEn";
import farmEn from "./en/farmEn";
import marketplaceEn from "./en/marketplaceEn";
import usersEn from "./en/users";
import reportEn from "./en/reportEn";
import dashboardEn from "./en/dashboardEn";
import grnEn from "./en/grnEn";
import userGuideEn from "./en/userGuideEn";
import cropManagementEn from "./en/cropManagementEn";
import constructionManagementEn from "./en/constructionManagementEn";
import appVersionEn from "./en/appVersionEn";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...masterEn,
            ...settingsEn,
            ...projectEn,
            ...farmEn,
            ...marketplaceEn,
            ...usersEn,
            ...reportEn,
            ...dashboardEn,
            ...grnEn,
            ...userGuideEn,
            ...cropManagementEn,
            ...constructionManagementEn,
            ...appVersionEn,
        }
    },
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;